export function readEmploymentField(employment, prefixedKey, shortKey) {
  if (!employment || typeof employment !== "object") return "";
  const prefixed = employment[prefixedKey];
  if (prefixed !== undefined && prefixed !== null && prefixed !== "") {
    return prefixed;
  }
  const short = employment[shortKey];
  return short !== undefined && short !== null ? short : "";
}

export function normalizeCurrentEmploymentForForm(currentEmployment) {
  if (!currentEmployment || typeof currentEmployment !== "object") {
    return null;
  }

  const emp = currentEmployment;
  const hasPrefixedFields =
    emp.employment_employer != null ||
    emp.employment_position != null ||
    emp.employment_type != null;

  if (hasPrefixedFields) {
    return { ...emp };
  }

  return {
    employment_employer: emp.employer || "",
    employment_supervisor_phone: emp.supervisor_phone || "",
    employment_position: emp.position || "",
    employment_type: emp.employment_type || emp.type || "",
    employment_income: emp.employment_income ?? emp.income ?? "",
    employment_pay_frequency: emp.employment_pay_frequency || emp.pay_frequency || "",
    employment_years_at: emp.employment_years_at ?? emp.years_at ?? "",
    employment_months_at: emp.employment_months_at ?? emp.months_at ?? "",
    employment_address_1: emp.employment_address_1 || emp.address_1 || "",
    employment_address_2: emp.employment_address_2 || emp.address_2 || "",
    employment_zip_code: emp.employment_zip_code || emp.zip_code || emp.zip || "",
    employment_city: emp.employment_city || emp.city || "",
    employment_county: emp.employment_county || emp.county || "",
    employment_state: emp.employment_state ?? emp.state ?? "",
    employment_country: emp.employment_country ?? emp.country ?? "",
    employment_email: emp.employment_email || emp.email || "",
  };
}
